<template><div><h1 id="monitoring" tabindex="-1"><a class="header-anchor" href="#monitoring"><span>Monitoring</span></a></h1>
<p>Monitoring — Berichte über definietre Vorgänge um Abweichungen vom Normalbetrieb festzustellen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Für das Monitoring werden Schreib-Zugriffe auf die Datenbank in einer Log-Datei gespeichert (jede Create-, Update- und Delete-Operation). Aus diesen Rohdaten können Berichte extrahiert und Abweichungen vom Normalbetrieb feststelllt werden. Es wird eine Liste von Berichten oder Kennzahlen aufgestellt. Eingerichtet ist ein wöchentliches Reporting. Bei allen Werten wird jeweils der Vorwochenwert und der Jahresdurchschnitt mit angegeben. Grössere Abweichungen zum Vorwochenwert (über 10%) werden rot angezeigt.</p>
<p>Pfad: <code v-pre>Systemverwaltung → Auswertungen → Monitoring → Monitoring</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<dl>
<dt>Jahr</dt>
<dd>Auswertungdjahr</dd>
<dt>Kalenderwoche</dt>
<dd>Kalenderwoche, die ausgewertet werden soll</dd>
<dt>Positionen für die Auswertung (diverse)</dt>
<dd>Definiert den Inhalt des Reports. Die Positionen sind einzeln wählbar:
<table>
<thead>
<tr>
<th>Thema</th>
<th>Bericht</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Personen und Adressen</td>
<td>Personen exportiert</td>
<td>Anzahl exportierter Personen (Datum,User/Anzahl/Segment/Job-id)</td>
</tr>
<tr>
<td></td>
<td>Adressen mutiert</td>
<td>Anzahl mutierte postalische Adressen (Datum/User/Anzahl)</td>
</tr>
<tr>
<td></td>
<td>Adressen refusiert</td>
<td>Anzahl erfasster Sperren auf Ebene Person, Kanal oder Adresse (Datum/User/Anzahl/Refuse)</td>
</tr>
<tr>
<td></td>
<td>Personenereignisse gelöscht</td>
<td>Gelöschte Personenereignisse (Datum/User/Anzahl/Ereignis)</td>
</tr>
<tr>
<td>Ereignisse</td>
<td>Ereignisse erfasst</td>
<td>Anzahl Ereignisse, eröffnet in der Stammtabelle (Datum/User/Ereignis)</td>
</tr>
<tr>
<td></td>
<td>Ereignisse mutiert</td>
<td>Anzahl Ereignisse, mutiert in der Stammtabelle (Datum/User/Ereignis)</td>
</tr>
<tr>
<td></td>
<td>Ereignisse gelöscht</td>
<td>Anzahl Ereignisse, gelöscht in der Stammtabelle (Datum/User/Ereignis)</td>
</tr>
<tr>
<td></td>
<td>Ereignisse Baumstruktur</td>
<td>Anpassung der Baumstruktur der Ereignisse in der Stammtabelle (Datum/User/alt/neu)</td>
</tr>
<tr>
<td>Buchungen</td>
<td>Buchungen eingelesen</td>
<td>Anzahl Importierte Buchungen mit dem Job Buchungen einlesen (Datum/User/Anzahl/Job-ID)</td>
</tr>
<tr>
<td></td>
<td>Buchungen mutiert</td>
<td>Anzahl Mutationen in den manuellen Buchungen (Datum/User/Anzahl)</td>
</tr>
<tr>
<td></td>
<td>Buchungen storniert</td>
<td>Anzahl Stornierungen in den manuellen Buchungen (Datum/User/Anzahl)</td>
</tr>
<tr>
<td></td>
<td>Buchungen umgebucht</td>
<td>Anzahl Umbuchungen in den manuellen Buchungen (Datum/User/Anzahl)</td>
</tr>
<tr>
<td>Benutzer</td>
<td>Benutzer erfasst</td>
<td>Anzahl erfasste Benutzer (Datum/User/erfasst)</td>
</tr>
<tr>
<td></td>
<td>Benutzer mutiert</td>
<td>Anzahl mutierte Benutzer (Datum/User/Änderung bei)</td>
</tr>
<tr>
<td></td>
<td>Benutzer Rechte</td>
<td>Jedes Hinzufügen/Entfernen eines Benutzers zu/von einer Gruppe wird gezählt (Datum/User/ft-Benutzer/Recht)</td>
</tr>
<tr>
<td></td>
<td>Benutzer Login</td>
<td>User-Logins zwischen 19.00 und 06.00 sowie an den Wochenenden. Benutzer &quot;Web&quot; ist ausgefiltert (Datum/User/Zeit)</td>
</tr>
<tr>
<td></td>
<td>Benutzergruppe Funktionen</td>
<td>Jedes Hinzufügen/Entfernen einer Benutzerfunktion zu/von einer Gruppe wird gezählt (Datum/User/Gruppe/Funktion)</td>
</tr>
<tr>
<td>Aufträge</td>
<td>Aufträge erfasst</td>
<td>Anzahl erfasste Aufträge (Datum/User/Anzahl)</td>
</tr>
<tr>
<td></td>
<td>Aufträge mutiert</td>
<td>Anzahl mutierte Aufträge (Datum/User/Anzahl)</td>
</tr>
<tr>
<td></td>
<td>Aufträge storniert</td>
<td>Anzahl stornierte Auftragspositionen (Datum/User/Anzahl)</td>
</tr>
<tr>
<td>Verdankungen</td>
<td>Spenden verdankt</td>
<td>Anzahl Verdankungen von Spenden (Datum/User/Anzahl/Job-ID)</td>
</tr>
<tr>
<td></td>
<td>Anlässe verdankt</td>
<td>Anzahl verdankte Anlässe (Datum/User/Anzahl/Job-ID)</td>
</tr>
<tr>
<td>andere</td>
<td>Korrespondenz produziert</td>
<td>Anzahl erstellte Korrespondenzen (Datum/User/Anzahl/Job-ID)</td>
</tr>
<tr>
<td></td>
<td>Exportformate angepasst</td>
<td>Jedes Hinzufügen/Entfernen eines Exportfeldes zu/von einem Exportformat (Datum/User/Anzahl/Exportformat/Anz. Felder)</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet nebst der grafischen Übersicht eine Liste mit den folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Datum</td>
<td>Datum</td>
</tr>
<tr>
<td>max. Anzahl</td>
<td>Die maximal Anzahl angemeldeter Benutzer (pro Tag)</td>
</tr>
<tr>
<td>angemeldete Benutzer</td>
<td>Benutzerkürzel der angemeldeten Benutzer</td>
</tr>
</tbody>
</table>
</div></template>


